import { validate, Network as BtcNetwork } from 'bitcoin-address-validation';
import KnownInternalNames from "../../knownIds";
import { NetworkType, AddressSelectionMode } from "../../types";
export const name = 'Bitcoin';
export class BitcoinAddressUtilsProvider {
    constructor() {
        this.providerName = name;
        this.networkType = NetworkType.Bitcoin;
        this.label = 'Bitcoin';
        this.selection = AddressSelectionMode.Auto;
    }
    supportsNetwork(network) {
        return KnownInternalNames.Networks.BitcoinMainnet.includes(network.name) || KnownInternalNames.Networks.BitcoinTestnet.includes(network.name);
    }
    isValidAddress(props) {
        const { address, network } = props;
        if (!address) {
            return false;
        }
        // No network (classification path) → accept either, matching the old detector's network-agnostic validate.
        if (!network) {
            return validate(address, BtcNetwork.mainnet) || validate(address, BtcNetwork.testnet);
        }
        const isTestnet = network.name.toLowerCase().includes("testnet");
        return validate(address, isTestnet ? BtcNetwork.testnet : BtcNetwork.mainnet);
    }
    addressFormat(props) {
        return props.address;
    }
}
